<template>
  <div class="classCompany">
    <div class="classCompanyTitle">
      <p>班级企业管理</p>
      <el-button plain size="mini" @click="createdClass">事务所创办</el-button>
    </div>

    <div class="classCompanyContent">
      <div class="cardAll">
        <el-card
          v-for="(o, index) in classCompany"
          :key="index"
          class="box-card"
          style="background-color: #f2f6fc"
        >
          <div class="cardContent" style="display: flex">
            <div class="cardImg" style="flex: 0.3">
              <img :src="o.companyLogo" style="height: 118px; width: 157px" />
            </div>
            <div
              class="cardText"
              style="
                flex: 0.65;
                padding: 0px 15px;
                display: flex;
                flex-direction: column;
              "
            >
              <p
                :title="o.companyName"
                style="
                  font-weight: 600;
                  font-size: 20px;
                  width: 250px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  line-height: 25px;
                "
              >
                {{ o.companyName }}
              </p>
              <div style="height: 55px; padding: 10px 0px">
                <p
                  :title="o.companyContext"
                  style="
                    font-size: 12px;
                    width: 250px;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 4;
                    text-overflow: ellipsis;
                  "
                >
                  {{ o.companyContext }}
                </p>
              </div>
              <div style="display: flex; justify-content: space-around">
                <span
                  style="font-size: 12px"
                  @click="employeeInformationTable(o)"
                >
                  人事管理
                </span>
                <span style="font-size: 12px" @click="enterOffice(o)"
                  >进入办公区</span
                >
              </div>
            </div>
            <div
              class="cardBtn"
              style="
                flex: 0.05;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding: 15px 0px;
              "
            >
              <i class="el-icon-delete" @click="del(o)"></i>
              <i class="el-icon-edit" @click="open_dialog(o)"></i>
            </div>
          </div>
        </el-card>
      </div>
      <!-- 班级公司管理分页 -->
      <div class="selectePages">
        <el-pagination
          @size-change="classCompanySizeChange"
          @current-change="classCompanyCurrentChange"
          :current-page.sync="totalObj.currentPage"
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="totalObj.pageSize"
          layout="sizes, prev, pager, next"
          :total="totalObj.total"
        ></el-pagination>
      </div>
    </div>

    <div>
      <el-dialog
        destroy-on-close
        class="dialog"
        width="500px"
        style="border-radius: 25px"
        :visible.sync="dialogVisible"
        title="事务所管理"
        center
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="事务所名称:" prop="companyName">
            <el-input
              style="width: 290px"
              v-model="ruleForm.companyName"
            ></el-input>
          </el-form-item>
          <el-form-item label="事务所简介:" prop="companyContext">
            <el-input
              style="width: 290px"
              type="textarea"
              v-model="ruleForm.companyContext"
            ></el-input>
          </el-form-item>

          <el-form-item label="项目包引入" prop="subjectId">
            <el-select
              multiple
              style="width: 290px"
              v-model="ruleForm.subjectId"
              placeholder="请选择活动区域"
            >
              <el-option
                v-for="item in subjectList"
                :key="item.id"
                :label="item.projectName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            class="upload_custom"
            label="事务所形象缩略图:"
            prop="companyLogo"
          >
            <el-upload
              :limit="1"
              :file-list="flieList"
              list-type="picture-card"
              ref="addUpload"
              :action="materialForm.url"
              :headers="headers"
              :on-success="handleAvatarSuccess"
            >
              <i class="el-input__icon el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <div style="display: flex; justify-content: center">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="handleSave('ruleForm')"
                >确 定</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import bus from "../../../bus/bus";
import * as api from "../../../api/marketingProjectManagement"; // 内容展示
import * as handleJump from '../../../utils/systemJump';

export default {
  data() {
    return {
      returnParameters: 2,
      flieList: [],
      WhetherHave: false,
      professional: sessionStorage.getItem("professional"),
      classCompany: [],
      subjectList: [],
      totalObj: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      ruleForm: {
        companyName: "",
        companyContext: "",
        companyLogo: "",
        subjectId: "",
      },
      //图片上传
      materialForm: {
        url: `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`,
        data: {
          savepath: "cjdd/resourse/",
        },
        fileName: "",
        id: "",
      },
      dialogVisible: false,
      //输入框验证规则
      rules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        companyContext: [
          { required: true, message: "请输入公司简介", trigger: "blur" },
        ],
        subjectId: [
          { required: true, message: "请选择项目", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    headers() {
      return {
        Authorization: "bearer " + localStorage.getItem("Authorization"),
      };
    },
  },
  created() {
    this.classCompanyInit();
  },
  methods: {
    // 审计跳转
    enterOffice(item) {
      handleJump.entrySys('sj', item.id ).then(res =>{
        window.open(res.jumpUrl)
      })
    },
    //查询班级公司列表
    classCompanyInit() {
      this.params = {
        professionalId: this.professional,
        pageSize: this.totalObj.pageSize,
        pageNo: this.totalObj.currentPage,
      };
      api.CompanyList(this.params).then((res) => {
        if (res.code == 0) {
          if (res.data.records.length < 1) {
            this.WhetherHave = true;
          } else {
            this.WhetherHave == false;
          }
          this.classCompany = res.data.records;
          this.totalObj.total = res.data.total;
        }
      });
    },

    //项目引用
    projectList() {
      this.params = {
        professionalId: this.professional,
      };
      api.projectList(this.params).then((res) => {
        if (res.code == 0) {
          this.subjectList = res.data.records;
        }
      });
    },

    //创建班级
    createdClass() {
      this.flieList = [];
      this.dialogVisible = true;
      this.ruleForm.companyContext = "";
      // this.ruleForm.companyLogo = "";
      this.ruleForm.companyName = "";
      this.ruleForm.subjectId = [];
      this.id = "";
      this.projectList();
      // if(this.$refs.addUpload !== undefined){
      //   this.$refs.addUpload.clearFiles()
      // }
    },
    //上传成功
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.ruleForm.companyLogo = res.data.newAttaUrl;
      } else {
        let fileId = file.uid;
        this.showUploadFileList.forEach((item) => {
          if (item.uid == fileId) {
            item.state = "上传失败";
          }
        });
        this.$message.error("格式不支持上传");
      }
    },
    //保存
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.companyLogo == "") {
            this.$message({
              message: "请上传图片",
              type: "warning",
            });
            return;
          }
          this.dialogVisible = false;
          let params = {
            id: this.id,
            companyContext: this.ruleForm.companyContext,
            companyLogo: this.ruleForm.companyLogo,
            companyName: this.ruleForm.companyName,
            professionalId: this.professional,
            projectIds: this.ruleForm.subjectId,
          };
          if (
            this.ruleForm.companyContext != "" &&
            this.ruleForm.companyLogo != "" &&
            this.ruleForm.companyName != "" &&
            this.ruleForm.subjectId != ""
          ) {
            if (this.id == "") {
              api.SaveCompany(params).then((res) => {
                if (res.code == 0) {
                  this.classCompanyInit();

                  this.$message({
                    message: "新增成功",
                    type: "success",
                  });
                }
              });
            } else {
              api.updateCompany(params).then((res) => {
                if (res.code == 0) {
                  this.classCompanyInit();
                  this.$message({
                    message: "修改成功",
                    type: "success",
                  });

                  // this.answerList = res.data
                }
              });
            }
          } else {
            this.dialogVisible = true;
            this.$message({
              message: "保存失败",
              type: "warning",
            });
          }
        } else {
          return false;
        }
      });
    },
    //删除
    del(a) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.id = a.id;
          let params = {
            id: this.id,
          };
          api.deleteCompany(params).then((res) => {
            if (res.code == 0) {
              this.classCompanyInit();
              // this.answerList = res.data
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //编辑时带参数
    open_dialog(a) {
      this.dialogVisible = true;
      this.flieList = [{ name: "", url: a.companyLogo }];
      this.projectList();
      this.ruleForm.companyName = a.companyName;
      this.ruleForm.companyContext = a.companyContext;
      this.ruleForm.companyLogo = a.companyLogo;
      this.id = a.id;
      this.ruleForm.subjectId = [];
      let params = {
        id: this.id,
      };
      api.findById(params).then((res) => {
        if (res.code == 0) {
          res.data.list.forEach((item) => {
            this.ruleForm.subjectId.push(item.projectId);
            this.ruleForm.subjectId = [...new Set(this.ruleForm.subjectId)];
          });
        }
      });
    },

    //分页
    classCompanySizeChange(val) {
      this.totalObj.pageSize = val;
      this.classCompanyInit();
    },
    classCompanyCurrentChange(val) {
      this.totalObj.currentPage = val;
      this.classCompanyInit();
    },
    //路由传值公司ID
    employeeInformationTable(val) {
      localStorage.setItem("returnParameters", this.returnParameters);
      let id = val.id;
      this.$router.push({
        path: "/auditNewRealTask/components/marketingProjectEditor",
        query: { id: id, subjectId: this.ruleForm.subjectId },
      });
    },
  },
};
</script>

<style lang="scss">
.classCompany {
  cursor: default;
  width: 1062px;
  height: 100%;
  //   & > div {
  //   height: 100%;
  // }
  .classCompanyTitle {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: white;
    p {
      color: #004e96;
      font-weight: 600;
      font-size: 20px;
      cursor: default;
    }
  }
  .classCompanyContent {
    height: 100%;
    .cardAll {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      max-height: calc(100% - 130px);
      overflow-y: auto;
      min-height: calc(100% - 130px);
      span,
      i {
        cursor: pointer;
      }
      .box-card {
        height: 150px;
        width: 100%;
        margin: 1.4%;
      }
    }
  }
  .selectePages {
    height: 50px;
    width: 100%;
    text-align: right;
    margin-top: 20px;
  }
  .el-dialog {
    border-radius: 25px;
    font-weight: 600;
  }
  .el-input,
  .el-textarea {
    width: 290px;
  }
  .el-form-item__content {
    margin-left: 0px !important;
  }
  .upload_custom {
    .el-upload--picture-card,
    .el-upload-list__item {
      width: 80px;
      height: 80px;
    }
    .el-input__icon {
      line-height: 80px;
    }
    .el-upload {
      line-height: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auditNewRealTask/components/classCompany.vue